// Dynamic Diesels — YouTube modal player (generic).
// Any element with data-yt-embed="<full embed URL>" opens the modal and
// loads that URL into the shared iframe. Modal is shared across sections
// (the hero callout + the YouTube grid + anywhere else we drop a tile).
// Clearing iframe.src on close stops playback.

(function () {
  'use strict';

  function init() {
    const modal = document.querySelector('.dd-yt-modal');
    if (!modal) return;

    const iframe = modal.querySelector('.dd-yt-modal__iframe');
    const closeBtn = modal.querySelector('.dd-yt-modal__close');

    // Wire all triggers on the page (also delegates future ones? no —
    // sections re-render on theme-editor changes, so we re-query in
    // shopify:section:load).
    bindTriggers();

    document.addEventListener('shopify:section:load', bindTriggers);

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    // Hero-linked visibility for the callout — kept from previous impl.
    const callout = document.querySelector('.dd-yt-callout');
    if (callout) {
      const hero =
        document.querySelector('[data-dd-hero]') ||
        document.querySelector('main .shopify-section');
      if (hero && 'IntersectionObserver' in window) {
        callout.classList.add('dd-yt-callout--offscreen');
        const io = new IntersectionObserver(
          ([entry]) => {
            callout.classList.toggle('dd-yt-callout--offscreen', !entry.isIntersecting);
          },
          { threshold: 0 }
        );
        io.observe(hero);
      }
    }

    function bindTriggers() {
      document.querySelectorAll('[data-yt-embed]').forEach((trigger) => {
        if (trigger.dataset.ytBound === '1') return;
        trigger.dataset.ytBound = '1';
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          openModal(trigger.getAttribute('data-yt-embed'));
        });
      });
    }

    function openModal(embedUrl) {
      if (!embedUrl) return;
      iframe.src = embedUrl;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      iframe.src = '';
      document.body.style.overflow = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
